import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        profilePic: null,
        completeUserData: {},
        isLoggedIn: !!localStorage.getItem('isLoggedIn'),
        userRole: localStorage.getItem('userRole'),
        userName: localStorage.getItem('userName'),
        userData: {},
        cart_length: 0,
    },
    mutations: {
        loginUser(state, item) {
            state.isLoggedIn = true
            console.log(item, "llogin")
            localStorage.setItem('token', item.token)
            localStorage.setItem('isLoggedIn', true)
            localStorage.setItem('userRole', item.role)
            state.userRole = item.role

            if (localStorage.getItem("userRole")) {
                if (localStorage.getItem("userRole") == 'User') {

                    router.push('/editSellerProfile')
                } else {
                    router.push('/')
                }
            }
        },

        logoutUser(state) {

            state.isLoggedIn = false
            state.isAdmin = false
            state.isSubAdmin = false
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem("token");
            localStorage.removeItem("userRole");
            localStorage.removeItem("userName");
            state.isLoggedIn = "";
            state.userRole = "";
            state.cart_length = 0;
            router.push('/')
        },
        userRole(state, item) {
            state.userRole = item
            if (item == "Admin") {
                state.isAdmin = true
                localStorage.setItem('isAdmin', true)
            } else if (item == "SubAdmin") {
                state.isSubAdmin = true
                localStorage.setItem('isSubAdmin', true)
            }
            localStorage.setItem("userRole", item);
        },
        userName(state, item) {
            state.userName = item
            localStorage.setItem("userName", item);
        },
        userData(state, item) {
            state.userData = item
            localStorage.setItem('userRole', item.role)
                // localStorage.setItem('token', item.token)
        },
        changeCart(state, item) {
            state.cart_length = item
        },
        sessionOut(state) {
            localStorage.removeItem("token");
            localStorage.removeItem('isLoggedIn');
            state.isLoggedIn = false
            router.push('/')
            state.cart_length = 0
        }
    },
    actions: {

    }
})